import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import { Context } from "../context";
import { getDataById, getVideo } from "./utils";
import { Metadata } from "./Metadata";
import { MetadataAdd } from "./MetadataAdd";
import { PlayerYoutube } from "./PlayerYoutube";

import { UserBadge } from './UserBadge';

import PerfectScrollbar from "react-perfect-scrollbar";
import { PlayerVideo } from "./PlayerVideo";
import { ContentInfo } from './ContentInfo';
import "react-perfect-scrollbar/dist/css/styles.css";
import { PlayerVideoHeader } from './PlayerVideoHeader';
import { Select } from '../uikit/Select';
import { UIaddToPlaylists } from '../uikit/UIaddToPlaylists';



//TODO: pass this structure to the Select element
export const defaultPlaylists = [
  {
    uniq: 'playlist_url_slug1',
    title: 'Best bevels',
    value: 1,
    emoji: '🧠',
  },
  {
    uniq: 'playlist_url_slug2',
    title: 'Team RC car highlights',
    value: 2,
    emoji: '🚗',
  },
  {
    uniq: 'playlist_url_slug3',
    title: 'Playlist 3',
    value: 3,
  },
]


export function PlayerInner({ history, match, location }) {
  // console.log("match = ", match);
  const context = useContext(Context);

  const [expanded, setExpanded] = useState(<true>
  </true>);

  const [videoId, setVideoId] = useState("");
  useEffect(() => {
    if (match.params["videoId"] !== videoId) {
      setVideoId(match.params["videoId"]);
    }
  }, [match]);

  const [duration, setDuration] = useState(0);

  const [frame, setFrame] = useState(0);

  const getInfo = (d) => setDuration(d);

  const videoUrl = `https://www.youtube.com/embed/${getDataById(
    context,
    "videos",
    match["params"]["videoId"],
    "url"
  )}`;

  const mp4 = getDataById(context, "videos", match["params"]["videoId"], "mp4");
  const sprite = getDataById(
    context,
    "videos",
    match["params"]["videoId"],
    "sprite"
  );
  // console.log("mp4 = ", mp4);

  const handleClick = () => {
    // history.push(`/list/${match.params["playlistId"]}/${id}`);
    // console.log(match);
    // console.log(history);
    // console.log(location);
    // debugger
    let path = match["path"];
    history.push(path.replace("/:videoId", ""));
  };


  return (<>


    <div className="l_c_v l_c_v--video">

      <div className="l_content">

        <div className="l_content_player">

          <PlayerVideoHeader videoId={videoId} />


          <div className="l_player_width">
            {/* <div className="v0 v0--lg"> */}
            <PlayerVideo
              videoId={videoId}
              expanded={expanded}
              key={mp4}
              getInfo={getInfo}
              setTime
              video={mp4}
              frame={frame}
              sprite={sprite}
            />
            {/* </div> */}
          </div>

          {/* <div className="x_content_info"> */}
          <PlayerInfo
            title={getDataById(context, 'videos', videoId, 'title')}
            userId={getDataById(context, 'videos', videoId, 'user')}
            date={getDataById(context, 'videos', videoId, 'date')}
          />
          {/* </div> */}

        </div>



        <div className="l_content_metadata">


          <PerfectScrollbar className="l_video_meta_scroll">

            <Metadata
              videoId={match["params"]["videoId"]}
              frame={frame}
              handleFrame={(n) => {
                setFrame(Math.floor(n));
              }}
            />

          </PerfectScrollbar>

          <ContentInfo
            videoId={match["params"]["videoId"]}
          />

        </div>



      </div>
    </div>

  </>);
}



export function PlayerInfo({ title, userId, date, playlists = defaultPlaylists }) {
  const context = useContext(Context);


  //TODO: dummy playlist handling
  const [activePlaylists, setActivePlaylists] = useState([])
  const playlistHandle = (value) => {
    let newPlaylistArray = JSON.parse(JSON.stringify(activePlaylists))

    if (newPlaylistArray.includes(value)) {
      newPlaylistArray.splice(newPlaylistArray.indexOf(value), 1)
    } else {
      newPlaylistArray.push(value)
    }
    setActivePlaylists(newPlaylistArray)
  }



  return (
    <>


      <div className="l_content_info">
        <div className="l_content_info_section">
          <div className="l_info_line">
            <div className="l_video_info_title">
              {title}
            </div>
          </div>

          {/* <div className="l_info_line">
            <div className="l_player_actions">
              <div className="x_button_container_left">
                <div className="x_button x_button--w x_button--active">
                  <div className="ico">
                    <div>bookmark</div>
                  </div>
                  <div className="x_button_labels">Bookmarked</div>
                </div>
                <div className="x_button x_button--w">
                  <div className="ico">
                    <div>playlist_add</div>
                  </div>
                  <div>
                    <div className="x_button_labels">Add to playlist</div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}


          <div className="x_content_info ">
            <div className="l_content_info_section">
              <div className="l_info_line">
                <UIaddToPlaylists
                  //TODO: pass actual playlists
                  playlists={defaultPlaylists}
                  //TODO: pass the function that writes a new array of paylists to the DB
                  handleChange={([]) => void (0)}
                />
              </div>
            </div>
          </div>

          <div className="x_content_info ">
            <div className="l_info_line">
              <div className="l_info_row">
                <div className="l_info_label">
                  <div>Created:</div>
                </div>
                <div className="l_info_value">
                  {date}
                </div>
              </div>
              {/* <div className="l_info_row">
              <div className="l_info_label">
                <div>Published:</div>
              </div>
              <div className="l_info_value">
                {date}
              </div>
            </div> */}
              <div className="l_info_row">
                <div className="l_info_label">
                  <div>Author:</div>
                </div>
                <div className="l_info_value">
                  <UserBadge
                    userId={userId}
                  />
                </div>
              </div>
              {/* <div className="l_info_row">
              <div className="l_info_label">
                <div>Owner:</div>
              </div>
              <div className="l_info_value">
                <UserBadge
                  userId={userId}
                />
              </div>
            </div> */}


              <div className="l_info_row">
                <div className="l_info_label">
                  <div>Access level:</div>
                </div>
                <div className="l_info_value">
                  <div className="x_user0">
                    <div className="x_access_icon">
                      <div className="ico">
                        <div>visibility</div>
                      </div>
                    </div>
                    <h5 className="x_user_name">
                      <span>
                        <strong>Everybody</strong>
                      </span>
                    </h5>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>


        {/* {context.user['id'] === userId && <div className="l_content_info_section l_content_info_section--private">
          <div>
            <div className="l_info_section_title">
              <div>My content actions</div>
            </div>
            <div className="l_player_actions">
              <div className="x_button_container_left">
                <div className="x_button x_button--w">
                  <div className="ico">
                    <div>unpublished</div>
                  </div>
                  <div className="x_button_labels">Unpublish</div>
                </div>
                <div className="x_button x_button--w">
                  <div className="ico">
                    <div>delete</div>
                  </div>
                  <div>
                    <div className="x_button_labels">Delete</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>} */}



      </div>




    </>
  )
}



export const Player = withRouter(PlayerInner);
